<div *transloco="let t" class="ion-text-begin table-padding table-controls">
  <ion-grid *ngIf="searchText || items.length > 0" class="ion-no-padding">
    <ion-row>
      <ion-col size="6">
        <telus-bulk-dropdown
          *ngIf="hasBulkActions && showBulkActionsButton"
          [actions]="actions"
          (selectedAction)="onAction($event)"
        ></telus-bulk-dropdown>

        <ion-button
          *ngIf="hasBulkActions && showBulkSaveButton && canCreate"
          [disabled]="(previewItems || checkedItems).length === 0"
          (click)="onAction('create')"
          class="telus-button"
          color="secondary"
        >
          <span class="telus-button-icon">
            {{ 'Save Data' }}
            <ion-icon slot="end" name="save"></ion-icon>
          </span>
        </ion-button>

        <ion-button
          *ngIf="showNewButton && canCreate"
          (click)="canCreate && onNewItem()"
          class="telus-button"
          color="secondary"
        >
          <span class="telus-button-icon">
            {{ t(type + button) }}
            <ion-icon slot="end" name="add-circle"></ion-icon>
          </span>
        </ion-button>

        <ion-button
          *ngIf="customButton?.pageAction && canDoAction(customButton?.pageAction)"
          (click)="onClickCustomButton()"
          class="telus-button"
          color="secondary"
        >
          <span class="telus-button-icon">
            {{ t(customButton.label) }}
            <ion-icon slot="end" name="add-circle"></ion-icon>
          </span>
        </ion-button>
      </ion-col>

      <ion-col size="2"></ion-col>

      <ion-col size="4">
        <div *ngIf="showSearchbar" class="telus-searchbar">
          <ion-searchbar
            animated
            [debounce]="1500"
            [placeholder]="t(type + '.search')"
            [ngModel]="externalSearchText"
            (ionChange)="getFilterValue($event)"
            (keydown.enter)="searchEnter($event)"
          ></ion-searchbar>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>

<div *transloco="let t" class="table-padding">
  <div *ngIf="items.length === 0">
    <p *ngIf="!searchText && showNewButton">{{ t(type + '.noDataFound') }}</p>
    <p *ngIf="searchText && !isSearching">{{ t('noSearchFound') }}</p>

    <div *ngIf="isSearching" class="ion-text-center">
      <ion-spinner color="primary"></ion-spinner>
    </div>

    <ion-button
      *ngIf="showNewButton && canCreate && !searchText"
      (click)="onNewItem()"
      class="telus-button"
      color="secondary"
    >
      <span class="telus-button-icon">
        {{ t(type + button) }}
        <ion-icon slot="end" name="add-circle"></ion-icon>
      </span>
    </ion-button>

    <ion-button
      *ngIf="customButton?.show && canDoAction(customButton.pageAction)"
      (click)="onClickCustomButton()"
      class="telus-button"
      color="secondary"
    >
      <span class="telus-button-icon">
        {{ t(customButton.label) }}
        <ion-icon slot="end" name="add-circle"></ion-icon>
      </span>
    </ion-button>
  </div>

  <ion-button
    *ngIf="canFetch && (filters.anyFilterIsActive === true || beFilters.anyFilterIsActive === true )"
    (click)="clearFilters()"
    class="table-config-button clear-filter-button"
    color="secondary"
    shape="round"
    fill="outline"
  >
    {{t('clearFilters')}}
    <ion-icon slot="icon-only" name="barcode"></ion-icon>
  </ion-button>
  <telus-table-options
    *ngIf="canFetch && ( (isAnyTypeOfConditionActive() === true) || (isAnyTypeOfConditionActive() === false && items.length > 0 ) || showToggleButton)"
    [labelText]="labelText"
    [showToggle]="showToggleButton"
    (editColumns)="showColumnsVisibilityFilter()"
    (toogle)="onToggle($event)"
  ></telus-table-options>

  <div
    *ngIf="canFetch && ( (isAnyTypeOfConditionActive() === true) || (isAnyTypeOfConditionActive() === false && items.length > 0 ))"
  >
    <ngx-datatable
      #ngxDatatable
      class="material telus-table fixed-header virtualized"
      [rows]="rows"
      [columnMode]="columnMode.force"
      [displayCheck]="displayCheck"
      [headerHeight]="headerHeight"
      [footerHeight]="50"
      rowHeight="auto"
      [loadingIndicator]="isLoading"
      [scrollbarV]="false"
      [scrollbarH]="true"
      (activate)="onRowClick($event)"
      [selected]="selected"
      [selectionType]="selectionType"
      [selectAllRowsOnPage]="false"
      (select)="onSelect($event)"
      [sortType]="allowSortBy? sortType.multi: sortType.single"
      [externalPaging]="true"
      [count]="((filters.results.length !==0 || filters.anyFilterIsActive) && searchText.length===0)? filters.results.length: pagination.meta.totalItems"
      [offset]="pagination.meta.currentPage"
      [limit]="pagination.meta.itemsPerPage"
      [rowIdentity]="rowIdentity || getRowId"
      [externalSorting]="allowSortBy"
      (page)="setPreviousPage($event) && setPage($event)"
      (sort)="onSort($event)"
    >
      <ngx-datatable-footer>
        <ng-template
          ngx-datatable-footer-template
          let-rowCount="rowCount"
          let-pageSize="pageSize"
          let-selectedCount="selectedCount"
          ,
          let-curPage="curPage"
          let-offset="offset"
        >
          <div>
            Showing {{((offset? offset: 0)*pageSize) + 1}} to {{
            math.min(((offset? offset: 0)*pageSize) + pageSize , rowCount)}} of
            {{rowCount}} items | Page {{(curPage)? curPage: 0}} of
            {{math.ceil(rowCount/pageSize) }}
          </div>

          <datatable-pager
            [pagerLeftArrowIcon]="'datatable-icon-left'"
            [pagerRightArrowIcon]="'datatable-icon-right'"
            [pagerPreviousIcon]="'datatable-icon-prev'"
            [pagerNextIcon]="'datatable-icon-skip'"
            [page]="curPage"
            [size]="pageSize"
            [count]="rowCount"
            [hidden]="!((rowCount / pageSize) > 1)"
            (change)="ngxDatatable.onFooterPage($event)"
          >
          </datatable-pager>
        </ng-template>
      </ngx-datatable-footer>

      <ngx-datatable-column
        [width]="30"
        [sortable]="false"
        [canAutoResize]="false"
        [draggable]="false"
        [resizeable]="false"
        [headerCheckboxable]="headerCheckboxable"
        [checkboxable]="checkboxable"
        class=""
      >
      </ngx-datatable-column>

      <ngx-datatable-column
        *ngFor="let col of activeColumns; let i = index"
        [name]="col.field"
        [sortable]="col.field.toLowerCase() !== 'actions'  && (customSorting.length === 0)? true: customSorting.includes(col.field)"
        [comparator]="col.comparator"
      >
        <ng-template ngx-datatable-header-template let-value="value">
          <ion-skeleton-text
            *ngIf="showSkeleton"
            animated
            style="width: 400px"
          ></ion-skeleton-text>

          <h3
            class="telus-header-label"
            *ngIf="col.field !== 'actions' && !showSkeleton"
          >
            {{ t(type + colLang + col.field) }}
            <ion-icon
              *ngIf="allowColumnSearch && col.type !== 'array' && (customFilters.length === 0)? true: customFilters.includes(col.field)"
              class="pointer filter"
              [ngClass]="{'filter-active': ((filters?.dict[col.field] !== undefined &&  filters.dict[col.field].isActive) || (beFilters?.dict[col.field] !== undefined &&  beFilters.dict[col.field].isActive)) }"
              (click)="showFiltersByColumn(col.field, $event)"
            ></ion-icon>
          </h3>
          <h3
            *ngIf="col.field === 'actions' && !showSkeleton"
            class="telus-header-label"
          >
            {{ t(col.field) }}
          </h3>
        </ng-template>

        <ng-template
          ngx-datatable-cell-template
          let-value="value"
          let-rowIndex="rowIndex"
        >
          <ion-skeleton-text
            *ngIf="showSkeleton"
            animated
            style="width: 400px"
          ></ion-skeleton-text>

          <div
            class="telus-item-label"
            *ngIf="col.field !== 'actions' && !showSkeleton"
          >
            <p
              *ngIf="col.type === 'raw'"
              class="form-input-item"
              [innerHTML]="value  | safe : 'html'"
            ></p>

            <p
              *ngIf="col.type !== typeOfColumns.array &&
              col.type !== typeOfColumns.boolean &&
              col.type !== typeOfColumns.link &&
              col.type !== typeOfColumns.raw"
              class="form-input-item"
            >
              {{ col.field !== 'actions' && col.type !== 'date' && col.type !==
              typeOfColumns.date ? value : formattedDate(value) }}
            </p>

            <!-- link -->
            <p class="form-input-item">
              <a
                *ngIf="(col.type === typeOfColumns.link) &&  value?.link && value.link !== undefined"
                (click)="onLinkClick($event, value?.link)"
                class="form-input-item"
                >{{ value?.text || '' }}</a
              >
            </p>

            <p
              *ngIf="(col.type === typeOfColumns.link) &&  (!value?.link || value.link === undefined)"
              class="form-input-item"
            >
              {{ value?.text || '' }}
            </p>
            <!-- ends: link -->

            <p
              class="form-input-item"
              *ngIf="col.type === typeOfColumns.boolean"
            >
              <span class="datatable-checkbox">
                <input
                  type="checkbox"
                  class="telus-checkbox-input"
                  color="secondary"
                  [checked]="value"
                />
              </span>
            </p>

            <p *ngIf="col.type === typeOfColumns.array" class="form-input-item">
              {{ value.length }}
            </p>
          </div>
          <div
            class="telus-item-label"
            *ngIf="col.field === 'actions' && canDelete && !showSkeleton"
          >
            <a
              *ngIf="canDelete"
              class="delete-button"
              (click)="onDelete(rowIndex,$event)"
            >
              <ion-icon
                *ngIf="showOnlyDeleteIcon"
                name="person-remove-outline"
              ></ion-icon>
              {{ showOnlyDeleteIcon ? '' : t('deleteHeader') }}
            </a>
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
</div>
